import {URL_API_FILE_UPLOAD, URL_API_UPLOAD_CONTACTS, RAW_DATA_DUMP_CLI,
RAW_DATA_DUMP_CRM , RAW_DATA_DUMP_CSAT, RAW_DATA_DUMP_COMPLIANCE, RAW_DATA_DUMP_TRANSACTION} from '../apiHitFile';
import { base64StringToBlob  } from 'blob-util';
import {showModalLogin} from '../Dashboard/UserActions';
let documents = ['Mapping Sheet','CRM', 'CLI']
export function DocumentNames(){
  return{
    type: 'DOCUMENT_NAME',
    payload: {documents}
  } 
}
export function fileUploadMapping(newData){
  let headers= new Headers()
  return (dispatch, getState) => {  
  dispatch(isPending())
  fetch(URL_API_FILE_UPLOAD, {
    method: 'POST',
    headers : headers,
    body:newData
  }).then(res=>res.json())
    .then(json => { 
     dispatch({type: "SCREEN_MESSAGE", screenMessage:json.message, isPending:false})
  })
  .catch(error =>{  dispatch({type: "FILE_ERROR", showerror:true, errmessage:"File Upload Failed", isPending:false})       })
 }
}
export function filecontactsUpload(newData){
  return (dispatch, getState) => {
    dispatch(isPending())
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization",currentToken);
  fetch(URL_API_UPLOAD_CONTACTS, {
    method: 'POST',
    headers : headers,
    body: newData
  }).then((res) => res.json()) 
    .then((json) =>{ 
      if(json.status === 1001){
     var blob = base64StringToBlob(json.value, 'application.xlsx')
     var blob1 = new Blob([blob], { type: "application/vnd.ms-excel" });
      var URL = window.URL || window.webkitURL;
      var a = document.createElement("a");
      a.href = URL.createObjectURL(blob1);
      a.download = "ContactResult.xlsx";
      a.click();
    //  var downloadUrl = URL.createObjectURL(blob1);
   //   document.download="ContactResult.xlsx" 
    //  document.location = downloadUrl;   
      dispatch({type: "FILE_ERROR", showerror:true, errmessage:"Successfully File Uploaded", isPending:false})
      } else if(json.status === 403){
          dispatch(showModalLogin())
      } else {
        dispatch({type: "FILE_ERROR", showerror:true, errmessage:"File Upload Failed ", isPending:false})   
      }      
    })
     .catch(error => { 
     dispatch({type: "FILE_ERROR", showerror:true, errmessage:"File Upload Failed", isPending:false})      
    })
  }
}
export function downLoadRawDataDump(data, REPORTNAME){
  return (dispatch, getState) => {  
    dispatch(isPendingRawDataCsat())
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(RAW_DATA_DUMP_CSAT, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(data)
    }).then((response) => {
      if(response.status === 200){
      response.blob().then(function(myBlob) {
          if(myBlob.size>0){
            window.URL = window.webkitURL || window.URL;
              var a = document.createElement('a');
              a.href = window.URL.createObjectURL(myBlob);
              a.download = REPORTNAME
              a.click();
              dispatch({type:"FILE_MODAL_PENDING_CSAT", isPending:false})
          } else {
            dispatch({type: "FILE_ERROR_CSAT", showerror:true, errmessage:"No Record Found", isPending:false})
          }
      });
     
      } 
      })
      .catch(error =>{ dispatch({type: "FILE_ERROR_CSAT", showerror:true, errmessage:"Could not Download CSAT Dump", isPending:false})})
    }
}
export function isPendingRawDataCsat(){
  return{
    type:'FILE_MODAL_PENDING_CSAT',
    isPending:true
  }
}
export function downLoadRawDataDumpCompliance(data, REPORTNAME){
  return (dispatch, getState) => {  
    dispatch(isPendingRawDataCompliance())
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(RAW_DATA_DUMP_COMPLIANCE, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(data)
    }).then((response) => {
      if(response.status === 200){
      response.blob().then(function(myBlob) {
        if(myBlob.size>0){
            window.URL = window.webkitURL || window.URL;
              var a = document.createElement('a');
              a.href = window.URL.createObjectURL(myBlob);
              a.download = REPORTNAME
              a.click();
              dispatch({type:"FILE_MODAL_PENDING_COMPLIANCE", isPending:false})
        } else {
          dispatch({type: "FILE_ERROR_COMPLIANCE", showerror:true, errmessage:"No Record Found", isPending:false})
        }
      });
     
      } 
      })
      .catch(error =>{ dispatch({type: "FILE_ERROR_COMPLIANCE", showerror:true, errmessage:"Could not Download Compliance Dump", isPending:false})})
    }
}
export function isPendingRawDataCompliance(){
  return{
    type:'FILE_MODAL_PENDING_COMPLIANCE',
    isPending:true
  }
}
export function downLoadRawDataDumpTransact(data, REPORTNAME){
  return (dispatch, getState) => {  
    dispatch(isPendingRawDataTransact())
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(RAW_DATA_DUMP_TRANSACTION, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(data)
    }).then((response) => {
      if(response.status === 200){
      response.blob().then(function(myBlob) {
            if(myBlob.size>0){
            window.URL = window.webkitURL || window.URL;
              var a = document.createElement('a');
              a.href = window.URL.createObjectURL(myBlob);
              a.download = REPORTNAME
              a.click();
              dispatch({type:"FILE_MODAL_PENDING_TRANSACT", isPending:false})
            } else {
              dispatch({type: "FILE_ERROR_TRANSACT", showerror:true, errmessage:"No Record Found", isPending:false})
            }
      });
     
      } 
      })
      .catch(error =>{ dispatch({type: "FILE_ERROR_TRANSACT", showerror:true, errmessage:"Could not Download Transactional Dump", isPending:false})})
    }
}
export function isPendingRawDataTransact(){
  return{
    type:'FILE_MODAL_PENDING_TRANSACT',
    isPending:true
  }
}
export function downLoadRawDataDumpcli(data, REPORTNAME){
  return (dispatch, getState) => {  
    dispatch(isPendingRawDatacli())
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(RAW_DATA_DUMP_CLI, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(data)
    }).then((response) => {
      if(response.status === 200){
      response.blob().then(function(myBlob) {
            if(myBlob.size>0){
            window.URL = window.webkitURL || window.URL;
              var a = document.createElement('a');
              a.href = window.URL.createObjectURL(myBlob);
              a.download = REPORTNAME
              a.click();
              dispatch({type:"FILE_MODAL_PENDING_CLI", isPending:false})
            } else {
              dispatch({type: "FILE_ERROR_CLI", showerror:true, errmessage:"No Record Found", isPending:false})
            }
      });
     
      } 
      })
      .catch(error =>{ dispatch({type: "FILE_ERROR_CLI", showerror:true, errmessage:"Could not Download CLI Dump", isPending:false})})
    }
}
export function isPendingRawDatacli(){
  return{
    type:'FILE_MODAL_PENDING_CLI',
    isPending:true
  }
}
export function downLoadRawDataDumpcrm(data, REPORTNAME){
  return (dispatch, getState) => {  
    dispatch(isPendingRawDatacrm())
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(RAW_DATA_DUMP_CRM, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(data)
    }).then((response) => {
      if(response.status === 200){
      response.blob().then(function(myBlob) {
            if(myBlob.size>0){
            window.URL = window.webkitURL || window.URL;
              var a = document.createElement('a');
              a.href = window.URL.createObjectURL(myBlob);
              a.download = REPORTNAME
              a.click();
              dispatch({type:"FILE_MODAL_PENDING_CRM", isPending:false})
            } else {
              dispatch({type: "FILE_ERROR_CRM", showerror:true, errmessage:"No Record Found", isPending:false})
            }
      });
     
      } 
      })
      .catch(error =>{ dispatch({type: "FILE_ERROR_CRM", showerror:true, errmessage:"Could not Download CRM Dump", isPending:false})})
    }
}
export function isPendingRawDatacrm(){
  return{
    type:'FILE_MODAL_PENDING_CRM',
    isPending:true
  }
}
export function isPending(){
  return{
    type:'FILE_MODAL_PENDING',
    isPending:true
  }
}  
export function closeModalPopUp(){
  return{
    type:'FILE_MODAL_CLOSE',
    showerror:false
  }
}  
export function resetScreenMessage(){
  return{
    type:'SCREEN_MESSAGE_RESET',
    screenMessage:""
  }
}